import axios from "axios";
import userStore from "./store/user-store";

const apiUrl = process.env.REACT_APP_API_URL;
export const apiClient = axios.create({
    baseURL: apiUrl,
    withCredentials: true,
});

let isRefreshing = false;
let failedQueue = [];
let currentToken = null;

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};

// Создаем интерцептор запросов один раз
apiClient.interceptors.request.use(
    config => {
        const token = currentToken || userStore.userAccessToken;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

apiClient.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;


        if (error.response?.status === 401 && !originalRequest._retry) {

            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({ resolve, reject });
                }).then(token => {
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    return apiClient(originalRequest);
                }).catch(err => {
                    return Promise.reject(err);
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            try {
                const response = await axios.post(`${apiUrl}/v1/auth/refresh`, null, {
                    withCredentials: true
                });
                
                const newToken = response.headers['x-auth-token'];

                if (!newToken) {
                    throw new Error('No token received from refresh endpoint');
                }

                currentToken = newToken;
                userStore.setUserAccessToken(newToken);
                
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                processQueue(null, newToken);
                
                return apiClient(originalRequest);
            } catch (refreshError) {
                currentToken = null;
                userStore.setUserAccessToken(null);
                processQueue(refreshError, null);
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }
        return Promise.reject(error);
    }
);